<template>
  <v-img
    :height="height"
    :width="width"
    class="rounded-lg"
    v-if="coverArt"
    :src="coverArt.contentUrl"
    :style="center ? 'margin: 0 auto' : ''"
  />
  <CoverImagePlaceholder
    v-else
    :center="center"
    :height="height"
    :width="width"
  />
</template>
<script>
import CoverImagePlaceholder from "@/components/CreatorTools/CoverImagePlaceholder";
export default {
  components: {
    CoverImagePlaceholder,
  },
  props: {
    height: { type: String, default: "11.2rem" },
    width: { type: String, default: "7rem" },
    coverArt: { type: Object, default: null },
    center: { type: Boolean, default: true },
  },
}
</script>